import { LocalStorageKeyType } from '@/tools/public'
import { WebLocalStorage } from '@xhgj/xh-jsutils'

export type GlobalStorageKey = LocalStorageKeyType | 'PRODUCT_FORBID_CHAR'
export const GlobalStorage = new WebLocalStorage<GlobalStorageKey>()
import { LocalStorageKeyType } from '@/tools/public'
import { WebLocalStorage } from '@xhgj/xh-jsutils'

export type GlobalStorageKey = LocalStorageKeyType | 'PRODUCT_FORBID_CHAR'
export const GlobalStorage = new WebLocalStorage<GlobalStorageKey>()
